import React, { useEffect, useState } from "react";
import WMLOGO from "./assets/images/WM-logo.svg";
import "./assets/fonts/Maax/Webfont/stylesheet.css";
import "./App.css";
import config from "./config";

const App = () => {
  const [isUnitedStates, setIsUnitedStates] = useState(null);
  useEffect(() => {
    const handleOneTrustGroupsUpdated = () => {
      const geo = window?.OneTrust?.getGeolocationData?.();
      setIsUnitedStates(geo);
    };
    window.addEventListener("OneTrustGroupsUpdated", handleOneTrustGroupsUpdated);
    return () => {
      window.removeEventListener("OneTrustGroupsUpdated", handleOneTrustGroupsUpdated);
    };
  }, []);
  const openChatForm = () => {
    window.CXBus &&
      window.CXBus.subscribe("WebChat.ready", (e) => {
        window.CXBus.command("WebChat.open");
      });
  };
  return (
    <div className="App">
      <header className="App-header">
        <img src={WMLOGO} alt="" width="100" height="50" className="App-logo" />
        <p className="App-header-primary">National Accounts</p>
        <p className="App-header-secondary">Chat Now</p>
      </header>
      <p className="App-greetings-text">
        Hi, I am Andrew, your virtual assistant.
      </p>
      <p className="App-greetings-text2">
        I'm here to help you anytime, anywhere.
      </p>
      <button type="submit" className="App-start-button" onClick={openChatForm}>
        {`Let's Start`}
      </button>
      <p style={{ color: "white", fontSize: 14, fontFamily: "Maax-Light" }}>
        Version: {config.version}
      </p>
      <div style={{ /*position: "absolute", bottom: 20, right: 20, left: 20,*/ display: "flex", gap: 20, flexWrap: "wrap", paddingBottom: 20 }} >
        <a style={{ fontSize: 14, color: "white", fontFamily: "Maax-Light", textDecoration: "none", cursor: "pointer" }} href="javascript:void(0)" onClick={() => window.Optanon.ToggleInfoDisplay()}>
          <img src="https://cdn.cookielaw.org/logos/static/opt_in_out_icon.png" alt="Privacy Choices" style={{ width: "2rem", height: 20, marginRight: 5, verticalAlign: "middle" }} rel="noreferrer" />
          Your Privacy Choices
        </a>
        <a style={{ fontSize: 14, color: "white", fontFamily: "Maax-Light", textDecoration: "none", cursor: "pointer" }} href="https://www.wm.com/us/en/privacy" target="_blank" rel="noreferrer">
          Privacy Policy
        </a>
        {isUnitedStates?.country === "US" &&
          // Show California Privacy Notice (English or French based on site language)
          <a style={{ fontSize: 14, color: "white", fontFamily: "Maax-Light", textDecoration: "none", cursor: "pointer" }} href="https://www.wm.com/us/en/privacy/california-notice" target="_blank" rel="noreferrer">
            California Privacy Notice
          </a>
        }
      </div>
    </div >
  );
};

export default App;
